import { render, staticRenderFns } from "./UserSettingsAI.vue?vue&type=template&id=01381e54&lang=pug"
import script from "./UserSettingsAI.vue?vue&type=script&lang=js"
export * from "./UserSettingsAI.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsAI.vue?vue&type=style&index=0&id=01381e54&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports